import type { insuranceCoverageApiSpec } from "@wingspanhq/wingspan-api-types";
import startCase from "lodash/startCase";

type IPolicyType = insuranceCoverageApiSpec.InsuranceCoverage["policyType"];

export const selectorPolicyTypeByPolicyType = (
  policyType: IPolicyType
): string => {
  return startCase(policyType);
};
